import React, {useEffect, useState} from "react"

import {api} from "../../api/api";
import {BE_ADDR} from "../../api/host";
import {Wrapper} from "./HeaderApp.style";
import {HeaderAppCheck} from "./HeaderAppCheck";

const HeaderApp = () => {
    const [state, setState] = useState([])

    useEffect(() => {
        async function caller() {
            const checks = JSON.parse(localStorage.getItem("checkList"))

            try {
                const res = await api.shareList()
                const arr = await res.data.filter(item => {
                    if ((!(localStorage.getItem("checkList")) || checks.includes(item.id) === false) && item.active) {
                        return {
                            ...item
                        }
                    }
                })
    
                return setState(arr)
            } catch (err) {
                // console.log("Error, ", err.response);
            }
        }
        caller()
    }, [])

    const removeItem = (id) => {
        const newState = state.filter(item => item.id !== id)
        setState(newState)
    }

    const downloadAction = (fileName) => {
        debugger
        const aLink = document.createElement("a")

        aLink.href = `${BE_ADDR}${fileName}`
        aLink.setAttribute("download", fileName)
        aLink.click()
    }

    return (
        <Wrapper>
            {
                state.map((item, index) => {
                    const removeHandle = () => removeItem(item.id)
                    const downloadHandle = () => {
                        // console.log(item.filename);
                        // debugger
                        downloadAction(item.filename)
                        removeHandle()
                    }

                    return <HeaderAppCheck
                        id={item.id}
                        downloadHandle={downloadHandle}
                        removeHandle={removeHandle}
                        logoName={item.logoname}
                        textMessage={item.text_message}
                        key={index}
                    />
                })
            }
        </Wrapper>
    )
}

export default HeaderApp